var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPinPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    x: "0px",
    y: "0px",
    viewBox: "7.84 2.61 84.32 94.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.59,13A10.41,10.41,0,1,0,50,2.61,10.42,10.42,0,0,0,39.59,13ZM55.4,13A5.41,5.41,0,1,1,50,7.61,5.41,5.41,0,0,1,55.4,13Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.16,71V59.29H63.3a7.51,7.51,0,0,0,7.5-7.5V38.46A14.52,14.52,0,0,0,56.3,24H43.7a14.52,14.52,0,0,0-14.5,14.5V51.79a7.51,7.51,0,0,0,7.5,7.5h1.14V71c-14.84,1.3-30,5.31-30,12.93,0,4.27,4.53,7.69,13.45,10.15C29,96.22,39.19,97.39,50,97.39s21-1.17,28.71-3.29c8.93-2.46,13.45-5.88,13.45-10.15C92.17,81.49,90,73.39,62.16,71Zm-2.5-31.55a2.5,2.5,0,0,0-2.5,2.5V82.36a2.35,2.35,0,0,1-4.64.48c0-.16,0-.32,0-.48V63.12a2.5,2.5,0,0,0-2.5-2.5H50a2.5,2.5,0,0,0-2.5,2.5V82.36c0,.16,0,.32,0,.48a2.35,2.35,0,0,1-4.64-.48V42a2.5,2.5,0,0,0-5,0V54.29H36.7a2.5,2.5,0,0,1-2.5-2.5V38.46A9.51,9.51,0,0,1,43.7,29H56.3a9.51,9.51,0,0,1,9.5,9.5V51.79a2.5,2.5,0,0,1-2.5,2.5H62.16V42A2.5,2.5,0,0,0,59.66,39.48Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPinPerson);
export default __webpack_public_path__ + "static/media/icon-pin-person.1400023c536a9d5635e3524a58aa37db.svg";
export { ForwardRef as ReactComponent };